var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"team-section-title"},[_vm._t("default"),(_vm.arrow)?_c('i',{staticClass:"icon fr"},[_vm._v("")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }